/*
 * Where the guided first run lives. No React or IO here so the gate rules
 * stay unit-testable.
 *
 *   /onboarding   the onboarding conversation (its sidebar links ask first)
 */
import { matchPath } from "react-router-dom";

import type { OnboardingStatus } from "./types";

export const ONBOARDING_PATH = "/onboarding";

export const isOnboardingPath = (pathname: string): boolean =>
  matchPath({ path: ONBOARDING_PATH, end: true }, pathname) !== null;

/** Only a member who has never started is sent there on sign-in. */
export const shouldRedirectToOnboarding = (
  status: OnboardingStatus | null | undefined
): boolean => status === "pending";

/** The checklist follows the member around the app until they finish or dismiss it. */
export const showsChecklist = (
  status: OnboardingStatus | null | undefined
): boolean => status === "pending" || status === "in_progress";
